export enum ViewGridToolbarGroupFilterQuickBlock {
  Root = 'ViewGridToolbarGroupFilterQuick',
}
